import './radios.scss';
import React, { Component } from 'react';
import RibbonsUtil from '../../utils/RibbonsUtil';
import store from '../../store';
import Translator from './../../requests/apa/Translator';
import { SHOW_MODAL, MODAL_CITIES_FILTER } from '../../actions/modal';
import Utils from '../../utils/Utils';
import logger from 'src/utils/logger/logger';

class CitiesFilter extends Component {
    constructor(props) {
        super(props);
        this.modal = {
            type: SHOW_MODAL,
            modalType: MODAL_CITIES_FILTER
        };
        this.state = {
            user: props.user,
            menuItems: [],
            city: {
                city: '',
                country: '',
                id: '',
                linkTo: '',
                nameCity: '',
                nameCountry: '',
                slug: '',
                state: ''
            },
            citiesFilterIsOpen: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const { countryCode } = this.props;
        if (countryCode !== nextProps.countryCode) {
            this.getCities(nextProps.user, nextProps.countryCode);
        }
    }

    componentDidMount() {
        const countryCode =
            this.props.countryCode === '' && this.props.user ? this.props.user.countryCode : this.props.countryCode;
        if (this.props.user !== undefined) {
            this.getCities(this.props.user, countryCode);
        }
        window.SpatialNavigation.makeFocusable();
    }
    getCities(user, countryCode) {
        const musicRb = new RibbonsUtil();
        musicRb
            .getRadiosApi('cities', user, { country_radio: countryCode })
            .then(resp => {
                const { cities } = resp.response;
                this.setState({ menuItems: cities });
            })
            .catch(error => {
                logger.error('Fail to get cities filter will not show: ' + error);
            });
    }

    toggleListCityFilter() {
        const { citiesFilterIsOpen, menuItems } = this.state;
        const { onSelectFilter } = this.props;
        if (!citiesFilterIsOpen) {
            this.modal.modalProps = {
                setCityTitle: city => this.setCityTitle(city),
                onSelectFilter: city => onSelectFilter(city),
                toggleListCityFilter: () => this.toggleListCityFilter(),
                menuItems: menuItems
            };
            store.dispatch(this.modal);
        }
        this.setState(prevState => {
            return { citiesFilterIsOpen: !prevState.citiesFilterIsOpen };
        });
    }

    setCityTitle(city) {
        this.setState({ city: city });
    }

    handleMouseEnter = (e) => {
        Utils.handleMouseEnter(e)
    }

    render() {
        const { title } = this.props;
        const { citiesFilterIsOpen } = this.state;
        return (
            <div className="city-filter">
                <nav className="nav_interno_2 filter2_2p">
                    <ul>
                        <li
                            className="focus-selector"
                            onClick={e => {
                                e.stopPropagation();
                                this.toggleListCityFilter();
                            }}
                        >
                            <a
                                id={String(`keyCMR-${Math.floor(10000 + Math.random() * 90000)}`)}
                                className={`focusable`}
                                href="#"
                                onClick={e => {
                                    e.stopPropagation();
                                    this.toggleListCityFilter();
                                }}
                                onMouseEnter={e => {
                                    this.handleMouseEnter(e);
                                }}
                            >
                                <span>
                                    {title === ''
                                        ? Translator.get('CITIES', 'CIUDADES').toUpperCase()
                                        : title.toUpperCase()}
                                </span>
                                <i
                                    className={`${
                                        citiesFilterIsOpen
                                            ? 'fa fa-angle-down rotate2 down'
                                            : 'fa fa-angle-down rotate2'
                                    }`}
                                />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }
}

export default CitiesFilter;



// WEBPACK FOOTER //
// ./src/containers/Radios/citiesFilter.jsx